import { TaxiCompanyList } from "../../GetDirectionAndFare/models/getFareSamplesParams";

export type TaxiCompanyConfigurations = {
  [key in TaxiCompanyList]: TaxiCompanyConfiguration;
};

export interface SCClickSection {
  asw: string,
  airportAccess: string,
  chatan: string,
  fukushima: string
}


export interface TaxiCompanyConfiguration {
  name:                         string;
  companyName:                  string;
  displayName:                  string;
  operatingCompanyName:         string;
  temporaryDisplayName:         string;
  hasPAYG_Tariff:               boolean;
  supportAirports:              string[];
  defaultAirportCode:           string;
  scClick: {
    result: string,
    temporaryReservation: SCClickSection,
    reservation: SCClickSection
  };
  cyName: {
    result: string,
    logo:   string
  };
  logo: {
    alt: string
  },
  contact: {
    isLinkMailAddress: string,
    messages: string[]
  }
  limit: {
    errorMessage: string,
    limitStartDays: number,
    limitDays: number,
    limitHours: number
  }
  tariffType: {
    [key: string]: string
  };
  supportAMC: string[],
  supportAMCPeriod: {
    start: string,
    end: string
  },
  supportPlacardName: boolean,
  ui: {
    // 対応荷物
    bags: Element[],
    // 選択できる車種
    carTypes: Element[],
    // 支払い方法
    paymentMethod: Element[],
    specifiedMethod: {
      [key: string]: {
        component: string;
        airport?: {
          [key: string]: boolean;
        }
      }
    }
  }
  whenTooLongDistance?: {
    bookable: boolean,
    nextAction: string
  },
  whenUnsupportedFixedFareArea: {
    bookable: boolean,
    nextAction: string
  };
  defaultCenter: {
    [key: string]: {
      municipality: string,
      position: {
        lat: number,
        lng: number
      }
    }
  },
  timePattern: TaxiTimePattern,
  supportDirection: string,
  defaultFlightPattern: DefaultFlightPattern
}

/** 搭乗便プルダウンの1セット（出発便pickup / 到着便dropOff）。 */
export interface FlightPatternSet {
  pickup: string[],
  dropOff: string[]
}

/**
 * 乗車日で出し分ける版の1期間。start / end は ISO8601 文字列。
 * 境界を省略した場合は無制限（start省略=過去全て、end省略=未来全て）として扱う。
 */
export interface FlightPatternPeriod extends FlightPatternSet {
  start?: string,
  end?: string
}

/**
 * 搭乗便プルダウンの定義。以下いずれかの形式を取る。
 * - フラット形式: `{ pickup, dropOff }` … 全乗車日で同一（従来互換）。
 * - 版形式: `{ [任意キー]: { start?, end?, pickup, dropOff } }` … 乗車日で出し分け。
 */
export type DefaultFlightPattern =
  | FlightPatternSet
  | { [period: string]: FlightPatternPeriod }

export interface Element {
  maxQuantity?: number;
  id: string,
  label: string
}

/** タクシー日付選択タイプ */
export enum TaxiTimePattern {
  /** 通常通り日付を選択できる */
  normal = 'normal',
  /** 選択肢の中から時刻を選択する */
  pulldown = 'pulldown'
}
